import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadRFP'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'アプリ開発 RFP 提案依頼書 ベンダー選定 要件定義'}
        image={'https://aitria.co.jp/images/img/download/rfp/ogp.png'}
        url={'https://aitria.co.jp/download/rfp/'}
        title="アプリ開発RFP作成のポイント | 資料ダウンロード | Aitria（アイトリア）"
        description="アプリ開発において、ベンダーの真価を引き出す「RFP（提案依頼書）」作成のポイントを解説 。手段ではなく「解決したい課題」を伝える実践的な書き方をご紹介します 。そのまま実務で使える無料テンプレート付き！"
      />
      <Template />
    </>
  )
}

export default Download
